function currency(value) {
    if (value === undefined || value === false || value === null) {
        console.error('Empty value passed to currency filter');
        console.error(value);
        return ''
    }

    if (typeof value == 'string') {
        value = value.replace(",", ".");
    }

    const formatter = new Intl.NumberFormat(
        window.i18n.locale.replace('_', '-'),
        {
            style: 'currency',
            currency: window.currency
        }
    )

    return formatter.format(value)
}

export { currency };